/* eslint-disable react/jsx-indent */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { BsFilter } from 'react-icons/bs';
import {
  MdAssignmentTurnedIn,
  MdAssignmentInd,
  MdAssignmentReturn,
  MdRemoveRedEye,
} from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { toastr } from 'react-redux-toastr';

import { CircularProgress, Radio } from '@material-ui/core';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { FormikProvider, useFormik } from 'formik';
import moment from 'moment';

import AtribuirUser from '~/assets/AtribuirUser.svg';
import ActionModal from '~/components/ActionModal';
import Button from '~/components/Button';
import ConfirmationModal from '~/components/ConfirmationModal';
import DataListSync from '~/components/DataListSync';
import FilterChips from '~/components/FilterChips';
import FormCamunda from '~/components/Formik/FormCamunda';
import InputSearchDebounce, {
  SearchInputImperativeProps,
} from '~/components/InputSearchDebounce';
import Modal from '~/components/Modal';
import SelectWithAvatar from '~/components/SelectWithAvatar';
import Sidesheet from '~/components/Sidesheet';
import PaginatedTable from '~/components/Table/PaginatedTable';
import { PaginatedTableProps } from '~/components/Table/PaginatedTable/interface';
import { useAuth } from '~/hooks/auth';
import { useNavigation } from '~/hooks/Navigation';
import { useSubmitModal } from '~/hooks/SubmitModal';
import history from '~/services/history';
import { IState } from '~/store';
import { getProcessesRequest } from '~/store/modules/processes/actions';
import { IProcessFile } from '~/store/modules/processes/types';
import {
  getTaskRequest,
  executeTaskRequest,
  getTaskFormRequest,
  unclaimTaskRequest,
  claimTaskRequest,
  getTasksRequest,
  getFilterParamsRequest,
  clearFilterParamsRequest,
  isExecutingTaskRequest,
} from '~/store/modules/tasks/actions';
import {
  AssignedTo,
  DueDate,
  IFilterTaskParams,
  IGetTasksParams,
  ITask,
} from '~/store/modules/tasks/types';
import { getUsersByGroupsRequest } from '~/store/modules/users/actions';
import { ICamundaUser, IUser } from '~/store/modules/users/types';
import colors from '~/styles/colors';
import { permissions } from '~/types/constants';

import TaskDetails from '../TaskDetails';
import FilterTasksForm from './FilterTasksForm';
import {
  Container,
  FormControl,
  RadioGroup,
  FormControlLabel,
  FilterButton,
  Wrapper,
  FilterWrapper,
  SidesheetCustomStyle,
  AssingTaskModalContainer,
  ModalContainer,
  HeaderContainer,
  ButtonsContainer,
  SelectInputContainer,
} from './styles';

interface FormTableData {
  processDefinitionNames?: string[];
  assigneeIn?: IUser[];
  assignedTo?: { label: AssignedTo; value: AssignedTo }[];
}

interface OptionProps {
  value: string;
  label: string;
}

type FilterParam = 'assigneeIn' | 'processDefinitionNames' | 'assignedTo';

moment.locale('pt-br');

const AssignedTasks: React.FC = () => {
  const [resetPage, setResetPage] = useState<boolean>(false);
  const [customLimit, setCustomLimit] = useState<number>(15);
  const [formCamundaTaskParams, setFormCamundaTaskParams] = useState<
    IGetTasksParams | undefined
  >(undefined);
  const [modalTaskAssignedFilter, setModalTaskAssignedFilter] = useState<
    boolean
  >(false);
  const [searchAssigned, setSearchAssigned] = useState<string>('');

  const [options, setOptions] = useState<OptionProps[] | null>(null);
  const [modalTaskForm, setModalTaskForm] = useState<boolean>(false);
  const [modalAssigneeTask, setModalAssigneeTask] = useState<boolean>(false);
  const [modalTaskDetail, setModalTaskDetail] = useState<boolean>(false);
  const [filterParams, setFilterParams] = useState<IFilterTaskParams>({});
  const [selectedTasks, setSelectTasks] = useState<Array<ITask>>([]);
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [actionModal, setActionModal] = useState<boolean>(false);
  const [reassignableTasks, setReassignableTasks] = useState<ITask>();
  const [taskFailures, setTaskFailures] = useState<Array<ITask>>([]);
  const [showCheckBox, setShowCheckBox] = useState<boolean>(false);
  const [selectedUser, setSelectedUser] = useState<ICamundaUser>();
  const [dataListModal, setDataListModal] = useState<boolean>(false);
  const [
    selectedUserCandidateGroups,
    setSelectedUserCandidateGroups,
  ] = useState<Array<string>>([]);
  const [usersActiveFiltered, setUserActiveFiltered] = useState<Array<any>>([]);
  const [disableButton, setDisableButton] = useState<boolean>(false);
  const loading = useSelector((state: IState) => state.tasks.loading);
  const loadingAssignee = useSelector(
    (state: IState) => state.tasks.loadingAssignee,
  );
  const sortOrder = useSelector((state: IState) => state.tasks.sortOrder);
  const task = useSelector((state: IState) => state.tasks.task);
  const taskExecuted = useSelector((state: IState) => state.tasks.taskExecuted);
  const taskAssigned = useSelector((state: IState) => state.tasks.taskAssigned);
  const taskUnassigned = useSelector(
    (state: IState) => state.tasks.taskUnassigned,
  );
  const assignedTasks = useSelector(
    (state: IState) => state.tasks.taskInstances,
  );

  const taskAssignedFailures = useSelector(
    (state: IState) => state.tasks.taskAssignedFailures,
  );

  const count = useSelector((state: IState) => state.tasks.countTasks);
  const processesDefinitions = useSelector(
    (state: IState) => state.processes.processes,
  );
  const activeUsers = useSelector(
    (state: IState) => state.users.activatedUsers,
  );

  const camundaUsers: Array<ICamundaUser> = useSelector(
    (state: IState) => state.users.camundaUsers,
  );

  const usersByGroups = useSelector(
    (state: IState) => state.users.usersByGroups,
  );
  const loadingUsersByGroups = useSelector(
    (state: IState) => state.users.loadingUsersByGroups,
  );

  const responseFilterParams = useSelector(
    (state: IState) => state.tasks.filterParams,
  );

  const responseSearchFilter = useSelector(
    (state: IState) => state.tasks.searchFilter,
  );

  const formRef = useRef<FormHandles>(null);
  const formTableRef = useRef<FormHandles>(null);
  const searchInputRef = useRef<SearchInputImperativeProps>(null);

  const dispatch = useDispatch();
  const { user, checkPermission } = useAuth();
  const { setCanNavigate } = useNavigation();
  const managerId = Number(user.personId);

  const { handler } = useSubmitModal({ disableError: true });

  const buildGetTasksParamsObject = useCallback(
    (overrideParams?: Partial<IGetTasksParams>): IGetTasksParams => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { assigneeIn, ...remainingFilterParams } = { ...filterParams };

      const taskParams: IGetTasksParams = {
        assigned: true,
        page: 1,
        limit: customLimit,
        sortBy: 'dueDate',
        sortOrder: 'asc',
        taskSearch: searchAssigned,
        assigneeIn: assigneeIn?.map((assignee) => String(assignee.id)) ?? [],
        ...remainingFilterParams,
        ...overrideParams,
      };

      switch (filterParams.assignedTo) {
        case AssignedTo.ME:
          taskParams.assigneeIn = [String(user.personId)];
          break;
        case AssignedTo.OTHERS:
          taskParams.assigneeNotIn = [String(user.personId)];
          break;
        default:
      }

      return taskParams;
    },
    [customLimit, filterParams, searchAssigned, user.personId],
  );

  const loadTasks = useCallback(
    (overrides?: Partial<IGetTasksParams>) => {
      const taskParams = buildGetTasksParamsObject(overrides);

      if (
        user.groups.length === 1 &&
        user.groups[0].id === 'supplier' &&
        checkPermission([permissions.VIEW_SUPPLIER_REQUEST])
      ) {
        Object.assign(taskParams, {
          ...taskParams,
          candidateGroups: ['supplier'],
          includeAssignedTasks: true,
        });
        dispatch(getTasksRequest(taskParams, user));
      }

      if (
        user.groups.length === 1 &&
        user.groups[0].id === 'client' &&
        checkPermission([permissions.VIEW_CLIENT_REQUEST])
      ) {
        Object.assign(taskParams, {
          ...taskParams,
          candidateGroups: ['client'],
          includeAssignedTasks: true,
        });
        dispatch(getTasksRequest(taskParams, user));
      }

      setFormCamundaTaskParams(taskParams);
      dispatch(getTasksRequest(taskParams, user));
    },
    [buildGetTasksParamsObject, checkPermission, dispatch, user],
  );

  const handleChangeRadio = (newDueDate: DueDate | null) => {
    const newFilterParams = { ...filterParams };

    switch (newDueDate) {
      case DueDate.ON_TIME:
        newFilterParams.dueDate = DueDate.ON_TIME;
        break;
      case DueDate.OVERDUE:
        newFilterParams.dueDate = DueDate.OVERDUE;
        break;
      default:
        delete newFilterParams.dueDate;
    }

    setFilterParams(newFilterParams);
    setResetPage(true);
    setCustomLimit(15);
  };

  const handleFilterParams = (data: FormTableData) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { assignedTo, processDefinitionNames, assigneeIn, ...rest } = {
      ...filterParams,
    };
    const newFilterParams: IFilterTaskParams = rest;

    if (
      data?.processDefinitionNames &&
      data.processDefinitionNames?.length > 0
    ) {
      newFilterParams.processDefinitionNames = data.processDefinitionNames;
    }

    if (data?.assignedTo && data.assignedTo?.length > 0) {
      newFilterParams.assignedTo = data.assignedTo[0].value;
    }

    if (
      newFilterParams?.assignedTo !== AssignedTo.ME &&
      data?.assigneeIn &&
      data.assigneeIn?.length > 0
    ) {
      newFilterParams.assigneeIn = data.assigneeIn.map((assignee) => assignee);
    }

    setFilterParams(newFilterParams);
  };

  const filterAssigneeInChips = (id: string): IFilterTaskParams => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { assigneeIn, ...rest } = { ...filterParams };
    const newFilterParams: IFilterTaskParams = rest;
    const filteredAssigneeIn = filterParams.assigneeIn?.filter(
      (assignee) => String(assignee.id) !== id,
    );

    if (filteredAssigneeIn && filteredAssigneeIn.length > 0) {
      newFilterParams.assigneeIn = filteredAssigneeIn;
    }

    return newFilterParams;
  };

  const filterProcessDefinitionNameChips = (
    name: string,
  ): IFilterTaskParams => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { processDefinitionNames, ...rest } = { ...filterParams };
    const newFilterParams: IFilterTaskParams = rest;
    const filteredProcessDefinitionNames = filterParams.processDefinitionNames?.filter(
      (processDefinitionName) => processDefinitionName !== name,
    );

    if (
      filteredProcessDefinitionNames &&
      filteredProcessDefinitionNames.length > 0
    ) {
      newFilterParams.processDefinitionNames = filteredProcessDefinitionNames;
    }

    return newFilterParams;
  };

  const filterAssignedToChips = (): IFilterTaskParams => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { assignedTo, ...newFilterTaskParams } = {
      ...filterParams,
    };

    return newFilterTaskParams as IFilterTaskParams;
  };

  const handleDeleteChip = (key: FilterParam, selectedChip?: string) => {
    let newFilterParams: IFilterTaskParams;

    if (key === 'assigneeIn' && selectedChip) {
      newFilterParams = filterAssigneeInChips(selectedChip);
    } else if (key === 'processDefinitionNames' && selectedChip) {
      newFilterParams = filterProcessDefinitionNameChips(selectedChip);
    } else if (key === 'assignedTo') {
      newFilterParams = filterAssignedToChips();
    } else {
      return;
    }

    setResetPage(true);
    setFilterParams(newFilterParams);
  };

  const handleChangeOrder = () => {
    setResetPage(true);
    setCustomLimit(15);
    if (selectedUser) {
      loadTasks({
        sortOrder: sortOrder === 'asc' ? 'desc' : 'asc',
        limit: 15,
        candidateGroups: selectedUserCandidateGroups,
        includeAssignedTasks: true,
      });
    } else {
      loadTasks({ sortOrder: sortOrder === 'asc' ? 'desc' : 'asc', limit: 15 });
    }
  };

  const handleExecuteTask = (task: ITask) => {
    setCanNavigate(true);
    dispatch(getTaskFormRequest(task));
    dispatch(isExecutingTaskRequest());
    dispatch(getFilterParamsRequest(filterParams, searchAssigned));
    history.push(`/task/${task.id}`);
  };

  const handleUnclaimTask = (tasks: ITask[]) => {
    const taskParams = buildGetTasksParamsObject();

    const taskIds = tasks.map((task) => task.id);

    const confirmOptions = {
      onOk: () =>
        handler(() => {
          dispatch(
            unclaimTaskRequest(taskIds, {
              params: taskParams,
              user,
            }),
          );
          setDisableButton(false);
        }),
      onCancel: () => {},
    };

    toastr.confirm(
      'Tem certeza que deseja desatribuir a tarefa?',
      confirmOptions,
    );
  };

  const handleOpenModalAssigneeTask = (task: ITask) => {
    dispatch(getUsersByGroupsRequest(task.candidateGroups));

    setModalAssigneeTask(!modalAssigneeTask);

    setReassignableTasks(task);
    setModalAssigneeTask(true);
  };

  const handleAssigneeManyTasks = (tasks: ITask[]) => {
    const taskParams = buildGetTasksParamsObject();

    if (
      user.groups.length === 1 &&
      checkPermission([permissions.VIEW_CLIENT_REQUEST])
    ) {
      Object.assign(taskParams, {
        ...taskParams,
        candidateGroups: ['client'],
        includeAssignedTasks: true,
      });
    }

    const taskIds = tasks.map((task) => task.id);

    handler(() => {
      dispatch(
        claimTaskRequest(
          taskIds,
          Number(selectedUser?.id),
          managerId,
          {
            params: taskParams,
            user,
          },
          true,
        ),
      );
    });

    setResetPage(true);
    setDisableButton(false);
  };

  const handleModalTaskDetail = (task: ITask | null) => {
    if (task) dispatch(getTaskRequest(task.id));

    setModalTaskDetail(!modalTaskDetail);
  };

  const handleChangePage = (page: number, limit: number) => {
    setCustomLimit(limit);
    if (selectedUserCandidateGroups.length > 0) {
      loadTasks({
        candidateGroups: selectedUserCandidateGroups,
        includeAssignedTasks: true,
        page,
        limit,
        sortOrder,
      });
    } else {
      loadTasks({ page, limit, sortOrder });
    }
  };

  const handleGetTotalCount = (): number => {
    switch (filterParams.dueDate) {
      case DueDate.ON_TIME:
        return count.onTime;
      case DueDate.OVERDUE:
        return count.overdue;
      default:
        return count.total;
    }
  };

  const handleGetStatusColor = (status: string) => {
    switch (status) {
      case 'Atrasada':
        return '#c11e1e';
      case 'Próximo a vencer':
        return '#ff8000';
      case 'No prazo':
        return '#808080';
      default:
        return undefined;
    }
  };

  const handleFilterUserOptions = (search: string) => {
    const filteredUsers = usersActiveFiltered.filter(
      (camundaUser) =>
        camundaUser.firstName.toLowerCase().indexOf(search.toLowerCase()) ===
          0 ||
        camundaUser.lastName.toLowerCase().indexOf(search.toLowerCase()) === 0,
    );

    return filteredUsers?.map((filteredUser) => ({
      id: filteredUser.id,
      label: `${filteredUser.firstName} ${filteredUser.lastName}`,
    }));
  };

  const tableProps: PaginatedTableProps<ITask> = {
    entities: assignedTasks,
    selectedEntities: showCheckBox
      ? [selectedTasks, setSelectTasks]
      : undefined,
    loading,
    columns: [
      {
        header: 'Processo',
        value: (task) => task.processDefinitionName,
      },
      {
        id: 'due',
        header: 'Prazo',
        value: (task) => (
          <>
            {moment(new Date(task.due)).format('DD/MM/YYYY')}
            <br />
            <span style={{ width: '95px' }}>{task.status}</span>
          </>
        ),
      },
      {
        header: 'Solicitação',
        value: (task) => task.nomeSolicitacao,
      },
      {
        header: 'Execução',
        value: (task) => task.nomeExecucao,
      },
      {
        header: 'Tarefa',
        value: (task) => task.name,
      },
      {
        header: 'Responsável',
        value: (task) => task.assigneeName,
      },
    ],
    sorting: {
      sortBy: 'due',
      sortOrder,
      onChange: () => handleChangeOrder(),
    },
    emptyTable: {
      title: 'Nenhuma tarefa atribuída',
      description:
        'O sistema ainda não possui nenhuma tarefa atribuída.\nContate o administrador.',
    },
    menu: [
      {
        label: 'Visualizar detalhes',
        Icon: MdRemoveRedEye,
        action: (task) => handleModalTaskDetail(task),
        permissions: [permissions.VIEW_DETAILS_TASK],
      },
      {
        label: 'Executar tarefa',
        Icon: MdAssignmentTurnedIn,
        action: (task) => handleExecuteTask(task),
        permissions: [permissions.EXECUTE_TASK],
        condition: (task) => String(task.assignee) === String(user.personId),
      },
      {
        label: 'Reatribuir tarefa',
        Icon: MdAssignmentInd,
        action: (task) => handleOpenModalAssigneeTask(task),
        permissions: [permissions.ASSIGN_TASK_TO_OTHER],
        disabled: loadingUsersByGroups,
      },
      {
        label: !loadingAssignee ? 'Desatribuir-me' : 'Desatribuindo...',
        Icon: MdAssignmentReturn,
        action: (task) => handleUnclaimTask([task]),
        permissions: [permissions.UNASSIGN_TASK],
        disabled: loadingAssignee,
        condition: (task) => task.assignee === String(user.personId),
      },
      {
        label: !loadingAssignee ? 'Desatribuir tarefa' : 'Desatribuindo...',
        Icon: MdAssignmentReturn,
        action: (task) => handleUnclaimTask([task]),
        permissions: [permissions.UNASSIGN_TASK_TO_OTHER],
        disabled: loadingAssignee,
        condition: (task) => task.assignee !== String(user.personId),
      },
    ],
    borderColor: (task) => handleGetStatusColor(task.status),
    paginationProps: {
      total: handleGetTotalCount(),
      onChange: (page: number, limit: number) => handleChangePage(page, limit),
      resetPage,
      onReset: (reseted) => setResetPage(reseted),
    },
    multipleActionOption:
      user.groups.length === 1 &&
      checkPermission([permissions.VIEW_CLIENT_REQUEST])
        ? [
            {
              label: 'Reatribuir Tarefas',
              icon: <MdAssignmentInd size={20} color={colors.primary} />,
              action: () => setDataListModal(true),
            },
          ]
        : [
            {
              label: 'Reatribuir Tarefas',
              icon: <MdAssignmentInd size={20} color={colors.primary} />,
              action: () => setDataListModal(true),
            },
            {
              label: 'Desatribuir Tarefas',
              icon: <MdAssignmentReturn size={20} color={colors.primary} />,
              action: () => {
                setShowCheckBox(true);
                setDisableButton(true);
                setFilterParams({});
              },
            },
          ],
    disableMultSelectButton: disableButton,
    loadingMultSelectButton: loading,
  };

  useEffect(() => {
    if (usersByGroups && usersByGroups.length > 0) {
      const allUsers: OptionProps[] = usersByGroups.map((taskUser) => {
        return {
          value: String(taskUser.id),
          label:
            Number(taskUser.id) === user.personId
              ? `${taskUser.firstName} ${taskUser.lastName} (Eu)`
              : `${taskUser.firstName} ${taskUser.lastName}`,
        };
      });

      const filteredUsers =
        filterParams.assignedTo === AssignedTo.ME
          ? allUsers.filter(
              (taskUser) => Number(taskUser.value) !== user.personId,
            )
          : allUsers;

      setOptions(filteredUsers);
    }
  }, [filterParams.assignedTo, user.personId, usersByGroups]);

  useEffect(() => {
    if (task) {
      if (task.form === null && task.formHTML === null) {
        const data = formTableRef.current?.getData() as FormTableData;

        const dataWithValue = Object.fromEntries(
          Object.entries(data).filter(([, value]) => {
            if (value && value !== '__/__/____') {
              return value;
            }

            return false;
          }),
        );

        const params: IGetTasksParams = {
          assigned: true,
          page: 1,
          limit: customLimit,
          sortBy: 'dueDate',
          sortOrder: 'asc',
          taskSearch: searchAssigned,
          ...dataWithValue,
        };

        const variables = {
          executionUserId: {
            value: user.id,
          },
          executionUserName: {
            value: `${user.firstName} ${user.lastName}`,
          },
        };

        const confirmOptions = {
          onOk: () => {
            const processFiles = [] as IProcessFile[];

            dispatch(
              executeTaskRequest(
                task.id,
                params,
                user,
                variables,
                processFiles,
              ),
            );
          },
          onCancel: () => {},
          enableHtml: true,
        };

        toastr.confirm(
          ((
            <>
              <h5>Tem certeza que deseja executar a tarefa?</h5>
              <br />
              <div>Essa tarefa não possui campos para preenchimento.</div>
            </>
          ) as unknown) as string,
          confirmOptions,
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, task, user]);

  useEffect(() => {
    if (taskExecuted) {
      setModalTaskForm(false);
    }
  }, [dispatch, taskExecuted]);

  useEffect(() => {
    if (taskAssigned) {
      setActionModal(true);
      setModalAssigneeTask(false);
      setShowCheckBox(false);
      setSelectTasks([]);
      setSelectedUser(undefined);
      setSelectedUserCandidateGroups([]);
    }
  }, [taskAssigned]);

  useEffect(() => {
    dispatch(getProcessesRequest());
  }, [dispatch]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { dueDate, ...evaluatedFilterParams } = filterParams;

    const canNavigate =
      !searchAssigned &&
      (!evaluatedFilterParams ||
        Object.entries(evaluatedFilterParams).length < 1);

    setCanNavigate(canNavigate);
    if (selectedUser && selectedUserCandidateGroups.length > 0) {
      loadTasks({
        page: 1,
        candidateGroups: selectedUserCandidateGroups,
        includeAssignedTasks: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchAssigned, filterParams]);

  useEffect(() => {
    if (!loadingAssignee && taskAssignedFailures?.length > 0) {
      const taskFailures = selectedTasks.filter((selectedTask) =>
        taskAssignedFailures.some(
          (taskAssignedFailure) => taskAssignedFailure.id === selectedTask.id,
        ),
      );

      setTaskFailures(taskFailures);
      setConfirmationModal(true);
    }
  }, [loadingAssignee, selectedTasks, taskAssignedFailures]);

  useEffect(() => {
    if (taskUnassigned) {
      setActionModal(true);
      setSelectTasks([]);
      setShowCheckBox(false);
    }
  }, [taskUnassigned]);

  useEffect(() => {
    const userSelected = camundaUsers.filter(
      (camundaUser) => selectedUser && camundaUser?.id === selectedUser?.id,
    );

    const filteredGroups = user.groups.filter((userGroup) =>
      userSelected[0]?.candidateGroups?.some(
        (userSelectedGroup: any) => userGroup.id === userSelectedGroup.id,
      ),
    );

    const groups = filteredGroups.map((filteredGroup) => filteredGroup.id);

    setSelectedUserCandidateGroups(groups);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [camundaUsers, selectedUser]);

  useEffect(() => {
    if (selectedUser && selectedUserCandidateGroups?.length > 0) {
      loadTasks({
        candidateGroups: selectedUserCandidateGroups,
        includeAssignedTasks: true,
      });
      setShowCheckBox(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUser, selectedUserCandidateGroups]);

  useEffect(() => {
    if (Object.keys(filterParams).length > 0) {
      dispatch(getFilterParamsRequest(filterParams, searchAssigned));
    }
  }, [dispatch, filterParams, searchAssigned]);

  useEffect(() => {
    if (responseFilterParams) {
      setFilterParams(responseFilterParams);
    }
    if (responseSearchFilter) {
      setSearchAssigned(responseSearchFilter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const filteredUsers: any = [];

    if (
      user.groups.length === 1 &&
      checkPermission([permissions.VIEW_CLIENT_REQUEST])
    ) {
      usersByGroups.forEach((userByGroup) => {
        const users = activeUsers.filter(
          (activeUser) => String(activeUser.id) === String(userByGroup.id),
        );

        filteredUsers.push(...users);
      });

      setUserActiveFiltered(filteredUsers);
    } else {
      setUserActiveFiltered(activeUsers);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadTasks({ page: 1 });
  }, [loadTasks]);

  const initialValues = {};

  const onSubmit = (data: any) => {
    const taskParams = buildGetTasksParamsObject();

    const { userSelected } = data;

    if (
      user.groups.length === 1 &&
      checkPermission([permissions.VIEW_CLIENT_REQUEST])
    ) {
      Object.assign(taskParams, {
        ...taskParams,
        candidateGroups: ['client'],
        includeAssignedTasks: true,
      });
    }

    if (reassignableTasks) {
      handler(() => {
        dispatch(
          claimTaskRequest(
            [reassignableTasks?.id],
            Number(userSelected[0].value.id),
            managerId,
            {
              params: taskParams,
              user,
            },
            true,
          ),
        );
      });
    }
    setResetPage(true);
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
  });

  return (
    <Container>
      <Wrapper>
        <FormControl>
          <RadioGroup row>
            <FormControlLabel
              control={<Radio />}
              label={`Todas (${count.total})`}
              checked={!filterParams || !filterParams.dueDate}
              onChange={() => handleChangeRadio(null)}
            />
            <FormControlLabel
              control={<Radio />}
              label={`Atrasadas (${count.overdue})`}
              checked={filterParams && filterParams.dueDate === DueDate.OVERDUE}
              onChange={() => handleChangeRadio(DueDate.OVERDUE)}
            />
            <FormControlLabel
              control={<Radio />}
              label={`No prazo (${count.onTime})`}
              checked={filterParams && filterParams.dueDate === DueDate.ON_TIME}
              onChange={() => handleChangeRadio(DueDate.ON_TIME)}
            />
          </RadioGroup>
        </FormControl>
        <FilterWrapper>
          <InputSearchDebounce
            ref={searchInputRef}
            placeholder="Buscar uma solicitação ou execução"
            getSearch={(search) => {
              setSearchAssigned(search);
            }}
            valueAlreadyExists={responseSearchFilter}
          />
          <FilterButton
            type="button"
            onClick={() => setModalTaskAssignedFilter(!modalTaskAssignedFilter)}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <>
                <BsFilter size={20} color="white" />
                Filtrar
              </>
            )}
          </FilterButton>
        </FilterWrapper>
      </Wrapper>

      <FilterChips
        filterParams={[
          {
            list: filterParams.assigneeIn,
            label: (assignee) => `${assignee.firstName} ${assignee.lastName}`,
            onDelete: (assignee) =>
              handleDeleteChip('assigneeIn', String(assignee.id)),
          },
          {
            list: filterParams.processDefinitionNames,
            label: (process) => process,
            onDelete: (process) =>
              handleDeleteChip('processDefinitionNames', process),
          },
          {
            condition: filterParams.assignedTo === AssignedTo.ME,
            label: 'Para mim',
            onDelete: () => handleDeleteChip('assignedTo'),
          },
          {
            condition: filterParams.assignedTo === AssignedTo.OTHERS,
            label: 'Para outros',
            onDelete: () => handleDeleteChip('assignedTo'),
          },
        ]}
        onClear={() => {
          setFilterParams({});
          dispatch(clearFilterParamsRequest());
        }}
      />

      <Sidesheet
        title="Filtro"
        open={modalTaskAssignedFilter}
        modalState={() => setModalTaskAssignedFilter(false)}
        sidesheetSize="450px"
      >
        <FilterTasksForm
          activeUsers={usersActiveFiltered}
          filterParams={filterParams}
          processDefinitions={processesDefinitions}
          onSubmit={(submitValues) => {
            handleFilterParams(submitValues);
            setModalTaskAssignedFilter(false);
            setResetPage(true);
          }}
        />
        <SidesheetCustomStyle />
      </Sidesheet>

      <PaginatedTable {...tableProps} />

      {selectedTasks.length >= 1 && (
        <ActionModal
          selectedItemsLength={selectedTasks.length}
          selectedUser={selectedUser}
          selectUserText="Reatribuir em massa para:"
          onClear={() => {
            setSelectTasks([]);
            setSelectedUser(undefined);
            setShowCheckBox(false);
            loadTasks();
            setDisableButton(false);
          }}
          buttonOptions={
            selectedUser
              ? [
                  {
                    icon: <MdAssignmentInd size={16} />,
                    label: 'Confirmar reatribuições',
                    action: () => {
                      handleAssigneeManyTasks(selectedTasks);
                    },
                    permissions: [permissions.ASSIGN_TASK_TO_OTHER],
                  },
                ]
              : [
                  {
                    icon: <MdAssignmentReturn size={16} />,
                    label: 'Confirmar desatribuições',
                    action: () => handleUnclaimTask(selectedTasks),
                    permissions: [permissions.UNASSIGN_TASK],
                  },
                ]
          }
          onSelectedItemsModalState={setConfirmationModal}
          open={actionModal}
          onOpenActionModal={setActionModal}
        />
      )}
      <ConfirmationModal<ITask>
        open={confirmationModal}
        setOpenModal={setConfirmationModal}
        selectedEntities={[selectedTasks, setSelectTasks]}
        title="Solicitações"
        loading={false}
        columns={[
          {
            header: 'Solicitação',
            value: (task) => task.nomeSolicitacao,
          },
          {
            header: 'Execução',
            value: (task) => task.nomeExecucao,
          },
          {
            header: 'Tarefa',
            value: (task) => task.name,
          },
        ]}
        failureList={taskFailures}
      />

      {modalTaskForm && (
        <Modal
          title={
            task === undefined
              ? 'Tarefa não possui formulário'
              : `Execução da tarefa: ${task?.name}`
          }
          loading={loading}
          open={modalTaskForm}
          modalState={(opened) => setModalTaskForm(opened)}
        >
          {task && formCamundaTaskParams && task.form && (
            <FormCamunda
              process={task}
              onSubmit={(variables, processFiles) => {
                dispatch(
                  executeTaskRequest(
                    task.id,
                    formCamundaTaskParams,
                    user,
                    variables,
                    processFiles,
                  ),
                );
              }}
            />
          )}
        </Modal>
      )}

      {/* TODO(Cabral): Passar taskInstanceId no lugar de processInstance */}
      <TaskDetails
        open={modalTaskDetail}
        modalState={() => handleModalTaskDetail(null)}
        taskInstance={task}
      />

      {modalAssigneeTask && usersByGroups.length > 0 && reassignableTasks && (
        <AssingTaskModalContainer>
          <Modal
            title=""
            loading={loading}
            open={modalAssigneeTask}
            modalState={(opened) => setModalAssigneeTask(opened)}
          >
            <ModalContainer>
              <HeaderContainer>
                <div>
                  <img src={AtribuirUser} alt="" style={{ height: '40px' }} />
                </div>
                <div style={{ marginLeft: '30px' }}>
                  <h1 style={{ margin: '0', fontSize: '22px' }}>
                    Responsável pela tarefa
                  </h1>
                  <p style={{ fontSize: '16px', color: '#777777' }}>
                    Selecione quem irá realizar a tarefa:
                  </p>
                </div>
              </HeaderContainer>

              <FormikProvider value={formik}>
                <Form
                  ref={formRef}
                  onSubmit={formik.handleSubmit}
                  style={{ marginLeft: '40px' }}
                >
                  <SelectInputContainer>
                    <SelectWithAvatar
                      name="userSelected"
                      options={usersByGroups.map((userByGroup) => ({
                        value: userByGroup,
                        label:
                          Number(userByGroup.id) === user.personId
                            ? `${userByGroup.firstName} ${userByGroup.lastName} (Eu)`
                            : `${userByGroup.firstName} ${userByGroup.lastName}`,
                      }))}
                      clearField={modalAssigneeTask}
                    />
                  </SelectInputContainer>
                  <ButtonsContainer>
                    <Button
                      variant="ghost"
                      type="button"
                      styles={{ border: 'none' }}
                      onClick={() => {
                        setModalAssigneeTask(false);
                      }}
                    >
                      CANCELAR
                    </Button>
                    <Button type="submit">
                      {loadingAssignee ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : reassignableTasks ? (
                        'CONFIRMAR'
                      ) : (
                        'CONFIRMAR'
                      )}
                    </Button>
                  </ButtonsContainer>
                </Form>
              </FormikProvider>
            </ModalContainer>
          </Modal>
        </AssingTaskModalContainer>
      )}

      {dataListModal && (
        <Modal
          title="Atribuição de tarefas"
          open={dataListModal}
          modalState={(opened) => setDataListModal(opened)}
          size="xs"
        >
          <DataListSync
            values={[
              {
                id: selectedUser?.id,
                label: `${selectedUser?.firstName} ${selectedUser?.lastName}`,
              },
            ]}
            onSubmit={(options) => {
              const newSelectedUser = usersActiveFiltered.find((camundaUser) =>
                options.some((option) => camundaUser.id === option.id),
              );
              setSelectedUser(newSelectedUser);
              setDisableButton(true);
              setFilterParams({});
            }}
            optionsData={usersActiveFiltered.map((camundaUser) => ({
              id: camundaUser.id,
              label: `${camundaUser.firstName} ${camundaUser.lastName}`,
            }))}
            onOpenModal={setDataListModal}
            onFilterOptions={(search) => handleFilterUserOptions(search)}
          />
        </Modal>
      )}
    </Container>
  );
};

export default AssignedTasks;
